import moment from 'moment-timezone';
import SelectGroup from '../components/SelectGroup/SelectGroup';
import ViewOfferDetails from './ViewOfferDetail/ViewOfferDetail';
import EditOfferDetails from './EditOfferDetail/EditOfferDetail';
import RepostOffer from './RepostOffer/RepostOffer';

export default {
    components: { SelectGroup, ViewOfferDetails, EditOfferDetails, RepostOffer },
    data: () => ({
        title: 'Posted Offers',
        active: false,
        tooltipActive: false,
        obj1: {name: 'obj1'},
        obj2: {name: 'obj2'},
        obj: null,
        posted_offers: {},
        item_id: null,
    }),
    async mounted() {
        try {
            const res = await this.$newpetehealthapi.get('/posted_offers')
            if (res && res.data) {
                this.posted_offers = res.data
            }
        } catch (e) {
            console.log('data', this.posted_offers)
        }
    },
    methods: {
        getItemId(id) {
            this.item_id = id;
        },
        clearFilter() {
            console.log('clearFilter');
        },
        getDate() {
            console.log('getDate')
        }
    },
    filters: {
        formatDate: function (val) {
            if (val) {
                return moment(String(val)).format('YYYY-MM-DD')
            }
        }
    },
}
